import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Vegetable from './Vegetables.jpg';
import sanoftCart from './sanoft-cart-design.png';
import whatsapp from './whatsapp.png';
import facebook from './facebook.png';
import styles from './styles.module.css';

export default function PageNotFound() {
  const history = useHistory();

  const gotToShop = (id) => {
    history.push(`/${id}`);
  };

  const gotToShopOne = () => {
    gotToShop(1);
  };

  const gotToShop2445 = () => {
    gotToShop(2445);
  };

  const gotToShop2718 = () => {
    gotToShop(2718);
  };

  return (
    <Grid item xs={6} sm={3} md={2}>
      <div className={styles.mainDiv}>
        <div className={styles.banner}>
          <div className={styles.bannerMain}>
            <div className={styles.welcome}>
              <b>Page Not Found!</b>
            </div>
            <div className={styles.flexRow}>
              <div className={styles.bannerDiv}>
                <div className={styles.bannerDivLeft}>
                  <div className={styles.bannerTitle}>
                    <h1>
                      <span onClick={gotToShop2445}>Sanoft</span> <span onClick={gotToShop2718}>DigiMenu</span>
                    </h1>
                    <h3>Launch Your Digital Menu with Sanoft</h3>
                    <span>
                      Sanoft DigiMenu helps you create a beautiful QR code menu and Cloud based POS for retail,
                      restaurant, or cafe in a simple &amp; easy manner.
                    </span>
                  </div>
                </div>
                <div className={styles.bannerDivleft}>
                  <img alt="" className={styles.bannerImg} src={Vegetable} />
                </div>
              </div>
              <img
                style={{ cursor: 'pointer' }}
                onClick={gotToShopOne}
                alt=""
                className={styles.bannerImg}
                src={sanoftCart}
              />

              <div style={{ display: 'flex' }}>
                <img
                  onClick={() => {
                    window.open('https://wa.link/wy6nie');
                  }}
                  className={styles.whatsappIcon}
                  src={whatsapp}
                  alt=""
                />
                <span>Whatsapp</span>
              </div>
              <div style={{ display: 'flex' }}>
                <img
                  onClick={() => {
                    window.open('https://www.facebook.com/sanoft');
                  }}
                  className={styles.whatsappIcon}
                  src={facebook}
                  alt=""
                />
                <span>facebook</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
}
